module.exports = __webpack_public_path__ + "static/media/test15_2.28f7cb83.png";